export function landingPageChip(isLanding = false) {
  return {
    // persisted
    landingPage: Alpine.$persist(null).using(sessionStorage),

    // was the chip showing on the *previous* page/view?
    // we persist this so navigation in the same tab keeps the info
    wasShowing: Alpine.$persist(false).using(sessionStorage),

    // runtime
    ready: false,

    get isVisible() {
      return (
        this.ready &&
        this.landingPage &&
        !this.sameUrl(this.landingPage, location.href)
      );
    },

    async init() {
      if (isLanding) {
        // on the landing page: remember it, but don't show the chip
        this.landingPage = this.canonical();
      }

      const shouldShowNow =
        this.landingPage && !this.sameUrl(this.landingPage, location.href);

      if (shouldShowNow) {
        // if it was NOT showing previously, we want the delayed / animated show
        if (!this.wasShowing) {
          await this.$nextTick();
          this.ready = true;
        } else {
          // it was already showing on the previous page → show immediately
          this.ready = true;
        }
        // now that it's showing, remember that for the next page
        this.wasShowing = true;
      } else {
        // not showing on this page
        this.ready = false;
        this.wasShowing = false; // <-- important: so next time we *will* delay again
      }
    },

    dismiss() {
      // user explicitly closes it → don't show right now
      this.landingPage = null;
      this.ready = false;
      this.wasShowing = false;
    },

    canonical() {
      const link = document.querySelector('link[rel=canonical]');
      return link?.href || location.href;
    },

    sameUrl(a, b) {
      try {
        const ua = new URL(a, location.origin);
        const ub = new URL(b, location.origin);
        const norm = (u) => {
          u.pathname = u.pathname.replace(/\/+$/, '') || '/';
          [
            'utm_source',
            'utm_medium',
            'utm_campaign',
            'utm_content',
            'utm_term',
            'gclid',
            'fbclid',
          ].forEach((p) => u.searchParams.delete(p));
          u.hash = '';
          return u.toString();
        };
        return norm(ua) === norm(ub);
      } catch {
        return a === b;
      }
    },
  };
}
